import { FileType } from "@/src/graphql/generated";
import { Path, Svg } from "@react-pdf/renderer";

const ICON_SIZE = 12;

const documentPath =
  "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z";

const chartPath =
  "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z";

const archivePath =
  "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5a1.125 1.125 0 0 0-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z";

const folderPath =
  "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z";

function PdfSvgIcon(props: { path: string; color: string }) {
  return (
    <Svg
      viewBox="0 0 24 24"
      width={ICON_SIZE}
      height={ICON_SIZE}
      style={{ marginRight: 4 }}
    >
      <Path d={props.path} fill={props.color} fillOpacity={0.7} />
    </Svg>
  );
}

function getFileIconColor(fileType: FileType): { path: string; color: string } {
  switch (fileType) {
    case FileType.Pdf:
      return { path: documentPath, color: "#b91c1c" };
    case FileType.Xlsx:
    case FileType.Xls:
      return { path: documentPath, color: "#15803d" };
    case FileType.Docx:
      return { path: documentPath, color: "#1d4ed8" };
    case FileType.Pptx:
      return { path: chartPath, color: "#db2777" };
    case FileType.Zip:
      return { path: archivePath, color: "#374151" };
    case FileType.Dicom:
      return { path: documentPath, color: "#a16207" };
    default:
      return { path: documentPath, color: "#6b7280" };
  }
}

export function PdfFileIcon(props: { fileType: FileType }) {
  const { path, color } = getFileIconColor(props.fileType);
  return <PdfSvgIcon path={path} color={color} />;
}

export function PdfFolderIcon() {
  return <PdfSvgIcon path={folderPath} color="#1d4ed8" />;
}
